import { render, staticRenderFns } from "./storageAssetsRegionPage.vue?vue&type=template&id=7295ea2b&scoped=true&"
import script from "./storageAssetsRegionPage.vue?vue&type=script&lang=js&"
export * from "./storageAssetsRegionPage.vue?vue&type=script&lang=js&"
import style0 from "./storageAssetsRegionPage.vue?vue&type=style&index=0&id=7295ea2b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7295ea2b",
  null
  
)

export default component.exports